import AesUtils from "./AesUtils";
import Storage from "@/uitls/Storage";
import axios from "axios";
import Platform from "@/config/platform";
import EventBus from "@/uitls/EventBus";
import { base64Encode } from "@/store/playerDomain"

import { _Q9, _K3 } from "./signature";
import { _S1 } from './whiteboxSecret';
import { _S0 } from './assetkey';

const myUid = Storage.get('uid');
// const piniaStore = usePiniaState();
// piniaStore.user.uid

export const createImNetWork = () => {
  const ApiNetWork = class {
    private address?: any;
    //是否可以强制刷新
    private isReload: boolean;
    //第几次检查域名了
    private netWorkIndex: number;
    private addressPromise?: Promise<string>;

    get(url: string, data: any = {}) {
      if (!data.check_id) {
        const customerId = Storage.get("customerId");
        if (customerId && customerId != '') {
          data.check_id = customerId;
          data.check_type = String(2);
        } else {
          // identifier
          const identifier = Storage.get("identifier")
          // console.log('是游客',identifier);
          data.check_id = identifier;
          data.check_type = String(1);
        }
      }
      console.log(url, data);


      return new Promise((resolve, reject) => {
        this.request(url, data, (e: any, result: any) => {
          if (result) {
            resolve(result);
          } else {
            reject(e);
          }
        });
      });
    }
    // 统计打点
    statisticsPost(resData, address?: string, address2?: string) {
      return new Promise((resolve, reject) => {
        let localUrl = localStorage.getItem('log_api_url');
        if (!localUrl || localUrl === 'undefined') {
          resolve(false); // 明确告诉外部：没上报
          return;
        }
        let url = localUrl + '/api/logAction';
       
        let { anchor_id, room_key, action_id, type_id, match_id } = resData || {};
        var data = {
          anchor_id: anchor_id || '',
          room_key: room_key || '',
          action_id: action_id || '14',

          type_id: type_id || '',
          match_id: match_id || '',

          check_id: '',
          check_type: '',
          client: process.env.isH5 || '1',
          channel: process.env.VUE_APP_CHANNEL,
          free_id: Storage.get('uid'),
          url: window.location.host
        }
        const customerId = Storage.get("customerId");
        if (customerId && customerId != '') {
          data.check_id = customerId;
          data.check_type = String(2);
        } else {
          // identifier
          const identifier = Storage.get("identifier")
          // console.log('是游客',identifier);
          data.check_id = identifier;
          data.check_type = String(1);
        }
        
        axios.post(url, data).then(({ data }) => {
          try {
            // const data = JSON.parse(json);
            resolve(data);
          } catch (e) {
            resolve(e);
          }
        })
          .catch((e) => {
            reject(e);
          });
      })
    }

    uploadGetAddress = () => {
      if (!this.address) {
        this.address = this.getAddress();
      }
      return this.address;
    }
    normalizeUrl = (url: string) => {
      if (!url) {
        return "";
      }
      return url[url.length - 1] == "/" ? url : url + "/";
    }
    getApiList = () => {
      const Api = process.env.VUE_APP_PHPApi as string;
      return Api.split(",").map((url) => this.normalizeUrl(url)).filter((url) => url);
    }
    setAddress = (url: string) => {
      const normalizedUrl = this.normalizeUrl(url);
      this.address = normalizedUrl;
      Platform.address = normalizedUrl;
      Storage.set("DOMAIN_LIST_PHP", normalizedUrl);
      return normalizedUrl;
    }
    // 首次进入或缓存域名失效时，多个业务接口会同时进来；用同一个 Promise 串住，避免重复探测域名。
    setAddressPromise = (promise: Promise<string>) => {
      const clearPending = () => {
        if (this.addressPromise == pending) {
          this.addressPromise = undefined;
        }
      };
      const pending = promise.then((url) => {
        clearPending();
        return url;
      }, (error) => {
        clearPending();
        throw error;
      });
      this.addressPromise = pending;
      return pending;
    }
    testAddress = async (url: string) => {
      const _url = this.normalizeUrl(url);
      const res = await fetch(_url + "app/encryptionVersion", {
        method: "GET",
      });

      if (!res.ok) {
        throw new Error(`status ${res.status}`);
      }

      await res.text();
      return _url;
    }
    // 业务请求发出前统一获取可用 API 域名；只在初始化/缓存校验阶段等待探测，普通请求不重复探测。
    getAvailableAddress = async (failedUrl = "") => {
      if (!this.address) {
        this.address = this.getAddress();
      }
      if (this.addressPromise && !failedUrl) {
        return this.addressPromise;
      }
      if (this.address && !failedUrl) {
        return this.address;
      }
      return this.setAddressPromise(this.checkHttp(this.getApiList(), true, failedUrl));
    }
    getAddress = () => {
      this.netWorkIndex = 0;
      this.isReload = false;

      //第一次进来，获取历史的baseurl
      let _url = Storage.get("DOMAIN_LIST_PHP");
      const cachedUrl = _url;

      const ApiList = this.getApiList();
      if (_url == null || _url == "") {
        // 没有缓存时仍先给 this.address 一个候选值，但真正业务请求会等待 checkHttp 找到可用域名后再发。
        _url = ApiList[Math.floor(Math.random() * ApiList.length)];

      }
      _url = this.normalizeUrl(_url);
      this.checkAEGIS();
      this.address = _url;
      if (cachedUrl) {
        // 有缓存也先检测缓存域名，缓存失效时自动切到可用备用域名，避免首屏请求打到坏域名。
        this.setAddressPromise(this.checkNetWork(_url, ApiList));
      } else {
        // 新域名首次访问没有缓存，必须先探测出可用 API，公共配置和首页接口会等待这个 Promise。
        this.setAddressPromise(this.checkHttp(ApiList, true));
      }
      return _url;
    };
    
    //单独对这个url检测一下，如果访问不通的，弹出刷新警告
    checkNetWork = async (url, apiList: string[]) => {
      try {
        const availableUrl = await this.testAddress(url);
        this.setAddress(availableUrl);
        return availableUrl;
      } catch (e) {
        console.log("这域名不通");
        this.isReload = true;
        return this.checkHttp(apiList, true, url);
      }
    }
    //检查是否维护状态
    async checkAEGIS() {
      // VUE_APP_AEGIS
      const url = process.env.VUE_APP_AEGIS as string;
      const urlList: Array<string> = url.split(",");
      for (let i = 0; i < urlList.length; i++) {
        //循环发送网络请求
        let _url = urlList[i];

        const res = await axios.get(_url).then((response) => {
          return response
        }).catch(() => {
          return null;
        })
        if (res && res.status && res.status == 200) {
          if (res.data.withdrawal == 1) {
            EventBus.emit("showAegis", true);
            return;
          } else {
            EventBus.emit("showAegis", false);
            return;
          }
        }
      }
    }

    //检查域名是否可用
    async checkHttp(ApiList: string[], doAdmin = false, failedUrl = "") {
      for (const url of ApiList) {
        let _url = this.normalizeUrl(url);
        if (!_url || (failedUrl && _url == this.normalizeUrl(failedUrl))) {
          continue;
        }

        try {
          await this.testAddress(_url);
          this.setAddress(_url);

          // 这里已经在业务请求发出前切到可用域名，不需要再刷新页面，避免首屏被二次 reload 打断。
          return _url; // ✅ 真正退出整个 checkHttp
        } catch (e) {
          // 失败就继续下一个
          continue;
        }
      }

      // 全部失败才会走到这里
      if (doAdmin) {
        console.log("去请求桶api");
        return this.toMains(failedUrl);
      }
      throw new Error("没有可用API域名");
    }

    //去请求桶拿地址
    async toMains(failedUrl = "") {
      // VITE_TXDOMAINCONFIG
      const txUri = process.env.VUE_APP_APITXDOMAINCONFIG as string;
      const aliUri = process.env.VUE_APP_APIALDOMAINCONFIG as string;
      const appID = process.env.VUE_APP_APPID as string;

      // 主列表全部不可用时，请求腾讯/阿里桶兜底；两个桶并发请求，谁返回可用列表就继续探测。
      const configRequests = [txUri, aliUri].filter((url) => url).map((url) => {
        return axios.get(url).then((response) => response).catch(() => null);
      });
      const responses = await Promise.all(configRequests);
      for (const response of responses) {
        try {
          if (response && response.status == 200) {
            const d: Array<string> = response.data[appID];
            if (Array.isArray(d)) {
              return await this.checkHttp(d, false, failedUrl);
            }
          }
        } catch (e) {
          continue;
        }
      }
      throw new Error("没有可用桶API域名");
    }

    buildUrl(url: any, params: any) {
      const paramsArr = [];
      for (const k in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(k)) {
          const v = params[k];
          if (v || v == 0) {
            paramsArr.push(k + "=" + encodeURIComponent(AesUtils.encrypt(v)));
          }
        }
      }
      if (paramsArr.length == 0) {
        return url;
      }
      url = url + "?" + paramsArr.join("&");
      return url;
    }
    async request(method: string, data: any, callback: any) {
      let url;
      if (/^https?:\/\//i.test(method)) {
        url = method;
      } else {
        let address = "";
        try {
          address = await this.getAvailableAddress();
        } catch (e) {
          callback && callback(e, null);
          return;
        }
        url = address + method;
      }
  
      let app_channel = process.env.VUE_APP_CHANNEL as string;
      const th = process.env.VUE_APP_Language as string;
      data.lang = th;
      data.client_channel = Platform.channel != 0 ? Platform.channel : app_channel;
      data.api_version = 1;
      data.version = process.env.VUE_APP_VERSION as string;
      data.client = data.client || Platform.client;
      data.timeNowClient = Date.now();
      let customerId = Storage.get("customerId");
      let token = Storage.get("token");

      if (customerId != "" && customerId != null && customerId != undefined) {
        data.customer_id = customerId;
      } else {
        data.customer_id = 0;
      }
      data.uid = Storage.get("uid");

      // uid: Storage.get("uid"),
      if (token != "" && token != null && token != undefined) {
        data.token = token;
      } else {
        data.token = "";
      }
      url = this.buildUrl(url, data);

      const host = new URL(url).host;
      const origin = new URL(url).origin;
      const endpoint = url.replace(origin, '');
      const DSDKLDFJLSDLSASSET = _S0();
      const SDKLSDLFLDSSS = _S1();
      const clientChannel = data.client_channel;
      const { authorization_header, amzdate } = await _Q9(SDKLSDLFLDSSS, DSDKLDFJLSDLSASSET, clientChannel, endpoint, host);

      console.log("authorization_header = ", authorization_header);
      console.log("amzdate = ", amzdate);

      const headers = {
        'x-amz-date': amzdate,
        Authorization: authorization_header
      };

      // 添加cookie到请求头
      axios.get(url, { headers }).then((res) => {
        if (res.status == 200) {
          let result = AesUtils.decrypt(res.data);
          try {
            result = JSON.parse(result);
            callback && callback(null, result);
          } catch (error) {
            console.log('网络错误', result, 'error', error);
            result = result;
            callback && callback(null, result);
          }
        }
      }).catch((e) => {
        // 这里不再因为业务接口失败切换域名，避免后端 4xx/5xx 或单接口异常导致重复请求和误切域名。
        callback && callback(e, null);
      });
    }
  };
  return new ApiNetWork();
};

export const ApiNetWork = createImNetWork();

export default ApiNetWork;
